module.exports = __webpack_public_path__ + "static/media/sopt2ru.0092db86.pdf";